<template>
  <!-- config.options -->
  <div class="dropdown-controls">
    <select
      v-bind:style="{marginBottom: '0.75rem', marginTop: '0.75rem', width: '100%', height: '2rem'}"
      :name="dropDownName"
      :id="`${dropDownName}`"
      v-model="selected"
      @change="$emit('input', selected)"
    >
      <template v-for="(control, i) in config.options">
        <option :value="control.value" :key="i">{{ control.value }}</option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    config: {
      required: true
    }
  },
  data() {
    return {
      dropDownName: Math.random()
        .toString(36)
        .substr(2, 5),
      mb: 0.75,
      selected: "",
    };
  },
  methods: {}
};
</script>
